import DealerData from '../pin-transfer-search/state/pinTransferDataRequest';

export const createUserDealerRequest = (userDealerDetails) => {

    let userDealerObj = {};

    const dealerpin = userDealerDetails.pin.split(',');
    const dealerIds1 = userDealerDetails.dealerIds.split(',');
    const dealerstatus = userDealerDetails.status.split(',');

    if (userDealerDetails.pin !== '') {

        userDealerObj = { ...userDealerObj, pin: dealerpin };

    } if (userDealerDetails.dealerIds !== '') {

        userDealerObj = { ...userDealerObj, dealerIds: dealerIds1 };

    } if (userDealerDetails.status !== '') {

        userDealerObj = { ...userDealerObj, status: dealerstatus };

    }
    return new DealerData({
        ...userDealerObj,
    });

};
